/**
 *  @class I18n
 *  @type {Object}
 *  @property {Function} get
 */

import { i18nOldAdapter } from '../i18n';

/**
 * create i18n object for old methods apis.
 * @param {t} t - the translate function received from i18n translate HOC
 * @param {string} locale - the full locale, including country code (eg. he_IL)
 * @param {string} googleLanguage - locale, formatted for google maps
 * @returns {I18n} i18n object
 */
export function createI18nObject(t, locale, googleLanguage) {
  const adapter = i18nOldAdapter(googleLanguage, locale);

  return {
    ...adapter,
    get: (...args) => {
      const str = args[0];
      const params = typeof args[1] === 'string' ? args[2] : args[1];

      const parameters = [adapter.get(str)];
      if (params && params.params) {
        parameters.push(params.params);
      }

      return t(...parameters);
    },
  };
}

function hasLocale(moment, locale) {
  return moment.locales().includes(locale);
}

async function prepareMomentLocale(moment, locale) {
  if (hasLocale(moment, locale)) {
    return locale;
  } else {
    await import(`moment/locale/${locale}`);
    return locale;
  }
}

async function loadMomentLocalizationData(moment, locale, language) {
  try {
    // First, try loading locale
    return await prepareMomentLocale(moment, locale);
  } catch (e) {}

  try {
    // In case loading the locale did not succeed, fall back to language
    return await prepareMomentLocale(moment, language);
  } catch (e) {
    // We have tried all the options by this point,
    // Indicate that requested locale is unavailable.
    return null;
  }
}

export async function setMomentLocale({ moment, locale } = {}) {
  if (typeof locale !== 'string') {
    return;
  }

  const myLocale = locale.replace('_', '-').toLowerCase();
  const language = myLocale.substr(0, 2);

  const localeToLoad = await loadMomentLocalizationData(moment, myLocale, language);

  if (localeToLoad && hasLocale(moment, localeToLoad)) {
    moment.locale(localeToLoad);
  }
}
